<div nz-row>
  <div nz-col nzSpan="18">
    <span class="pageTitle">Partner Query Request</span>
  </div>
  <div nz-col nzSpan="6">
    <div class="button-container" style="display: flex; justify-content: flex-end; align-items: center; float: right;">
      <button nz-button (click)="exportAsPDF()">
        <i nz-icon nzType="file-pdf" nzTheme="outline" style="color: white;"></i> Export to PDF
      </button>

    </div>
  </div>
</div><br/>
<div *ngIf="queryModel.Clarification_Query_Code>0" class="create-query-container">
  <partner-view-query *ngIf="currentUser.Is_Partner" [queryModel]="queryModel">
  </partner-view-query>  
  <div *ngIf="!currentUser.Is_Partner">
    <app-update-query *ngIf="queryPermission.canUpdateQuery" [queryPermission]="queryPermission" [queryModel]="queryModel">
    </app-update-query>
    <app-internal-user-view-query *ngIf="!queryPermission.canUpdateQuery"  [queryModel]="queryModel">
        </app-internal-user-view-query>
  </div>
</div>